import { render, staticRenderFns } from "./MagneticLnductor.vue?vue&type=template&id=cb66159a&scoped=true"
import script from "./MagneticLnductor.vue?vue&type=script&lang=js"
export * from "./MagneticLnductor.vue?vue&type=script&lang=js"
import style0 from "./MagneticLnductor.vue?vue&type=style&index=0&id=cb66159a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb66159a",
  null
  
)

export default component.exports